import { gql } from '@apollo/client';

export const fetchEntitlementListForIncludedProducts = gql`
  query fetchEntitlementListForIncludedProducts(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $id) {
      id
      productSubscriptionsInPPC(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        nodes {
          id
          entitlementNumber
          productId
          logoId
          productName
          cloudSiteHostname
        }
      }
    }
  }
`;
